import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { Button } from '../../components/primitives';

const CallToAction = () => {
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate('/create-facility-resource-event');
  };

  return (
    <Box
      sx={{
        mt: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        borderRadius: 2,
        p: 3,
        maxWidth: 600,
        mx: 'auto',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontWeight: 400,
          color: '#000000',
          mb: 2,
          textAlign: 'center',
        }}
      >
        Can't find what you're looking for?
      </Typography>
      <Button
        variant="outlined"
        onClick={handleCreateClick}
      >
        Create It!
      </Button>
    </Box>
  );
};

export default CallToAction;
